(function () {
  var globalCache = window.__SEESOFA_3D_CACHE__;

  if (!globalCache) {
    globalCache = {
      assetUrls: new Map(),
      pending: new Map(),
      posters: new Set(),
      modelViewerPromise: null
    };
    window.__SEESOFA_3D_CACHE__ = globalCache;
  }

  function toNumber(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function normalizeName(value) {
    return String(value || "").trim().toLowerCase();
  }
  function findMaterialByNames(materials, preferredNames) {
  if (!Array.isArray(materials) || !materials.length) {
    return null;
  }

  var normalizedNames = preferredNames.map(normalizeName);

  return (
    materials.find(function (material) {
      return normalizedNames.includes(normalizeName(material && material.name));
    }) ||
    materials.find(function (material) {
      var materialName = normalizeName(material && material.name);

      return normalizedNames.some(function (name) {
        return materialName.indexOf(name) !== -1;
      });
    }) ||
    null
  );
}

  function parseNameList(value) {
    if (!value) {
      return null;
    }

    var names = String(value)
      .split(",")
      .map(function (entry) {
        return normalizeName(entry);
      })
      .filter(Boolean);

    return names.length ? new Set(names) : null;
  }

  function safeJsonParse(text) {
    try {
      return JSON.parse(text);
    } catch (error) {
      console.warn("SEESOFA 3D viewer: invalid JSON payload.", error);
      return null;
    }
  }

  function normalizeHexColor(value) {
    var color = String(value || "").trim().replace(/^#/, "").toLowerCase();

    if (color.length === 3) {
      color = color
        .split("")
        .map(function (character) {
          return character + character;
        })
        .join("");
    }

    if (!/^[0-9a-f]{6}$/.test(color)) {
      color = "272727";
    }

    return "#" + color;
  }

  function hexToRGBA(hex) {
    var color = normalizeHexColor(hex).replace("#", "");

    return [
      parseInt(color.substring(0, 2), 16) / 255,
      parseInt(color.substring(2, 4), 16) / 255,
      parseInt(color.substring(4, 6), 16) / 255,
      1
    ];
  }

  function preloadPoster(url) {
    if (!url || globalCache.posters.has(url)) {
      return;
    }

    globalCache.posters.add(url);

    var image = new Image();
    image.decoding = "async";
    image.src = url;
  }

  function preloadAsset(url) {
    if (!url) {
      return Promise.resolve(null);
    }

    if (globalCache.assetUrls.has(url)) {
      return Promise.resolve(globalCache.assetUrls.get(url));
    }

    if (globalCache.pending.has(url)) {
      return globalCache.pending.get(url);
    }

    var request = fetch(url, {
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Asset request failed with status " + response.status);
        }

        return response.blob();
      })
      .then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        globalCache.assetUrls.set(url, objectUrl);
        globalCache.pending.delete(url);
        return objectUrl;
      })
      .catch(function (error) {
        globalCache.pending.delete(url);
        console.warn("SEESOFA 3D viewer: preload failed for", url, error);
        return url;
      });

    globalCache.pending.set(url, request);
    return request;
  }

  function getUrlExtension(url) {
    try {
      var parsed = new URL(url, window.location.href);
      var pathname = parsed.pathname || "";
      var match = pathname.match(/\.([a-z0-9]+)$/i);
      return match ? match[1].toLowerCase() : "";
    } catch (error) {
      return "";
    }
  }

  function canUseBlobModelSource(url) {
    return getUrlExtension(url) === "glb";
  }

  function warmModelRequest(url) {
    if (!url) {
      return Promise.resolve(null);
    }

    if (canUseBlobModelSource(url)) {
      return preloadAsset(url);
    }

    return fetch(url, {
      credentials: "omit",
      mode: "cors",
      cache: "force-cache"
    })
      .then(function () {
        return url;
      })
      .catch(function () {
        return url;
      });
  }

  function ensureModelViewerLibrary() {
    if (window.customElements && window.customElements.get("model-viewer")) {
      return Promise.resolve();
    }

    if (globalCache.modelViewerPromise) {
      return globalCache.modelViewerPromise;
    }

    globalCache.modelViewerPromise = new Promise(function (resolve, reject) {
      if (!window.customElements || !window.customElements.whenDefined) {
        reject(new Error("Custom Elements API is not available in this browser."));
        return;
      }

      var existingScript = document.querySelector('script[data-seesofa-model-viewer="true"]');

      function finishWhenDefined() {
        window.customElements
          .whenDefined("model-viewer")
          .then(resolve)
          .catch(reject);
      }

      if (existingScript) {
        finishWhenDefined();
        return;
      }

      var script = document.createElement("script");
      script.type = "module";
      script.async = true;
      script.crossOrigin = "anonymous";
      script.dataset.seesofaModelViewer = "true";
      script.src = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      script.addEventListener("load", finishWhenDefined, { once: true });
      script.addEventListener(
        "error",
        function () {
          globalCache.modelViewerPromise = null;
          reject(new Error("The model-viewer library could not be loaded."));
        },
        { once: true }
      );
      document.head.appendChild(script);
    });

    return globalCache.modelViewerPromise;
  }

  function waitForViewerLoad(viewer, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var timeoutId = window.setTimeout(function () {
        cleanup();
        reject(new Error("The 3D model load timed out."));
      }, timeoutMs || 18000);

      function cleanup() {
        window.clearTimeout(timeoutId);
        viewer.removeEventListener("load", handleLoad);
        viewer.removeEventListener("error", handleError);
      }

      function handleLoad() {
        cleanup();
        resolve();
      }

      function handleError(event) {
        cleanup();
        reject(new Error((event && event.detail && event.detail.type) || "The 3D model failed to load."));
      }

      viewer.addEventListener("load", handleLoad, { once: true });
      viewer.addEventListener("error", handleError, { once: true });
    });
  }

  function waitForNextFrame() {
    return new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        resolve();
      });
    });
  }

  function findFirstProductForm(root) {
    var section = root.closest(".shopify-section");

    if (section) {
      var localForm = section.querySelector('form[action*="/cart/add"]');
      if (localForm) {
        return localForm;
      }
    }

    return document.querySelector('form[action*="/cart/add"]');
  }

  function getFormElementsByName(form, name) {
    if (!form || !name) {
      return [];
    }

    return Array.prototype.filter.call(form.elements, function (element) {
      return element.name === name;
    });
  }

  function getSelectedFormValue(form, optionName) {
    var name = "options[" + optionName + "]";
    var elements = getFormElementsByName(form, name);

    if (!elements.length) {
      return null;
    }

    if (elements[0].tagName === "SELECT") {
      return elements[0].value || null;
    }

    var selected = elements.find(function (element) {
      return element.checked;
    });

    return selected ? selected.value : null;
  }

  function setFormValue(form, optionName, value) {
    if (!form || !optionName || !value) {
      return;
    }

    var name = "options[" + optionName + "]";
    var elements = getFormElementsByName(form, name);

    if (!elements.length) {
      return;
    }

    if (elements[0].tagName === "SELECT") {
      if (elements[0].value !== value) {
        elements[0].value = value;
        elements[0].dispatchEvent(new Event("change", { bubbles: true }));
      }
      return;
    }

    elements.forEach(function (element) {
      if (element.value === value && !element.checked) {
        element.checked = true;
        element.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  function setFormVariantId(form, variantId) {
    if (!form || !variantId) {
      return;
    }

    var elements = getFormElementsByName(form, "id");

    elements.forEach(function (element) {
      if (String(element.value) !== String(variantId)) {
        element.value = variantId;
        element.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  function workerFactory(queue, workerFn) {
    function worker() {
      if (!queue.length) {
        return Promise.resolve();
      }

      var item = queue.shift();
      return workerFn(item).then(function () {
        return worker();
      });
    }

    return worker;
  }

  function ViewerController(root) {
    var dataElement = root.querySelector("[data-seesofa-3d-data]");

    this.root = root;
    this.data = dataElement ? safeJsonParse(dataElement.textContent) : null;

    if (!this.data) {
      return;
    }

    this.models = Array.isArray(this.data.models)
      ? this.data.models.filter(function (model) {
          return model && model.src;
        })
      : [];
    this.fallbackModel = this.data.fallbackModel && this.data.fallbackModel.src ? this.data.fallbackModel : null;
    this.defaultModel = this.models[0] || this.fallbackModel || null;
    this.defaultPoster = this.data.defaultPoster || (this.defaultModel && this.defaultModel.poster) || null;
    this.variants = Array.isArray(this.data.variants) ? this.data.variants : [];
    this.visibleOptionNames = parseNameList(this.data.visibleOptionNames);
    this.textureCache = new Map();
    this.selectedVariant = null;
    this.selectedOptions = [];
    this.currentViewerSrc = null;
    this.currentModelLoadPromise = null;
    this.appliedMaterialKey = null;
    this.formSyncInFlight = false;
    this.loadToken = 0;
    this.closeTimer = null;
    this.isOpen = false;

    this.trigger = root.querySelector("[data-seesofa-3d-open]");
    this.modal = root.querySelector("[data-seesofa-3d-modal]");
    this.dialog = root.querySelector("[data-seesofa-3d-dialog]");
    this.viewerPanel = root.querySelector("[data-seesofa-3d-viewer-panel]");
    this.closeButton = root.querySelector("[data-seesofa-3d-close]");
    this.retryButton = root.querySelector("[data-seesofa-3d-retry]");
    this.viewer = root.querySelector("[data-seesofa-3d-viewer]");
    this.loadingState = root.querySelector("[data-seesofa-3d-loading]");
    this.status = root.querySelector("[data-seesofa-3d-status]");
    this.errorState = root.querySelector("[data-seesofa-3d-error]");
    this.errorTitle = root.querySelector("[data-seesofa-3d-error-title]");
    this.errorText = root.querySelector("[data-seesofa-3d-error-text]");
    this.optionGroupsContainer = root.querySelector(".seesofa-3d__option-groups");
    this.optionGroups = Array.prototype.slice.call(root.querySelectorAll("[data-option-group]"));
    this.optionButtons = Array.prototype.slice.call(root.querySelectorAll("[data-option-value]"));
    this.productForm = findFirstProductForm(root);
    this.portalPlaceholder = null;

    if (!this.trigger || !this.modal || !this.viewer) {
      root.hidden = true;
      return;
    }

    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleOpenIntent = this.handleOpenIntent.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleRetry = this.handleRetry.bind(this);

    this.init();
  }

  ViewerController.prototype.init = function () {
    this.mountModalToBody();
    this.bindEvents();
    this.setModalState("closed");

    var initialVariant =
      this.findVariantById(this.data.selectedVariantId) ||
      this.findVariantFromForm() ||
      this.variants[0] || {
        id: this.data.selectedVariantId || "seesofa-3d-default",
        title: "Product",
        available: true,
        options: [],
        materials: {
          fabricTexture: null,
          frameColor: "#272727"
        }
      };

    this.applyVariant(initialVariant, { syncForm: false });
    this.setLoading(false);
    this.clearError();
    this.updateStatus("preparing");

    if (this.data.preloadEnabled) {
      this.schedulePreload();
    }
  };

  ViewerController.prototype.mountModalToBody = function () {
    if (!this.modal || !document.body || this.modal.parentNode === document.body) {
      return;
    }

    this.portalPlaceholder = document.createComment(
      "seesofa-3d-modal-" + (this.data && this.data.productId ? this.data.productId : "instance")
    );
    this.modal.parentNode.insertBefore(this.portalPlaceholder, this.modal);
    document.body.appendChild(this.modal);
  };

  ViewerController.prototype.bindEvents = function () {
    var self = this;

    this.trigger.addEventListener("click", function () {
      self.openModal();
    });
    this.trigger.addEventListener("mouseenter", this.handleOpenIntent, { passive: true });
    this.trigger.addEventListener("focus", this.handleOpenIntent, { passive: true });
    this.trigger.addEventListener("touchstart", this.handleOpenIntent, { passive: true });

    this.closeButton.addEventListener("click", function () {
      self.closeModal();
    });

    this.modal.addEventListener("click", function (event) {
      if (event.target.hasAttribute("data-seesofa-3d-backdrop")) {
        self.closeModal();
      }
    });

    if (this.retryButton) {
      this.retryButton.addEventListener("click", this.handleRetry);
    }

    this.optionButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        self.handleOptionClick(button);
      });
    });

    if (this.productForm) {
      this.productForm.addEventListener("change", this.handleFormChange);
    }
  };

  ViewerController.prototype.setModalState = function (state) {
    this.modal.dataset.state = state;
    this.modal.setAttribute("aria-hidden", state === "closed" ? "true" : "false");

    if ("inert" in this.modal) {
      this.modal.inert = state === "closed";
    }
  };

  ViewerController.prototype.getAllModels = function () {
    return this.models.length ? this.models.slice() : this.fallbackModel ? [this.fallbackModel] : [];
  };

  ViewerController.prototype.getModelForVariant = function (variant) {
    if (!variant) {
      return this.defaultModel;
    }

    if (variant.featuredMediaId) {
      var mediaId = String(variant.featuredMediaId);
      var directModel = this.models.find(function (model) {
        return String(model.id) === mediaId && model.src;
      });

      if (directModel) {
        return directModel;
      }
    }

    return this.defaultModel;
  };

  ViewerController.prototype.getModelUrl = function (variant) {
    var model = this.getModelForVariant(variant);
    return model && model.src ? String(model.src).trim() : null;
  };

  ViewerController.prototype.handleOpenIntent = function () {
    if (this.selectedVariant) {
      this.loadVariant(this.selectedVariant, { highPriority: true });
    }
  };

  ViewerController.prototype.handleKeydown = function (event) {
    if (event.key === "Escape") {
      event.preventDefault();
      this.closeModal();
      return;
    }

    if (event.key !== "Tab" || !this.isOpen) {
      return;
    }

    var focusable = this.getFocusableElements();

    if (!focusable.length) {
      event.preventDefault();
      this.dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  ViewerController.prototype.getFocusableElements = function () {
    if (!this.dialog) {
      return [];
    }

    return Array.prototype.filter.call(
      this.dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ),
      function (element) {
        return !element.hidden && element.offsetParent !== null;
      }
    );
  };

  ViewerController.prototype.handleRetry = function () {
    if (this.selectedVariant) {
      this.loadVariant(this.selectedVariant, { highPriority: true, forceReload: true });
    }
  };

  ViewerController.prototype.handleFormChange = function () {
    if (this.formSyncInFlight) {
      return;
    }

    var variant = this.findVariantFromForm();

    if (variant && (!this.selectedVariant || variant.id !== this.selectedVariant.id)) {
      this.applyVariant(variant, { syncForm: false });
      if (this.isOpen) {
        this.loadVariant(variant, { highPriority: true });
      }
    }
  };

  ViewerController.prototype.schedulePreload = function () {
    var models = this.getAllModels();
    var modelUrls = Array.from(
      new Set(
        models
          .map(function (model) {
            return model.src;
          })
          .filter(Boolean)
      )
    );

    var posterUrls = Array.from(
      new Set(
        models
          .map(function (model) {
            return model.poster;
          })
          .concat([this.defaultPoster])
          .filter(Boolean)
      )
    );

    var textureUrls = Array.from(
      new Set(
        this.variants
          .map(function (variant) {
            return variant.materials && variant.materials.fabricTexture;
          })
          .filter(Boolean)
      )
    );

    var begin = function () {
      ensureModelViewerLibrary().catch(function () {
        return null;
      });

      posterUrls.forEach(preloadPoster);

      var tasks = [];
      var modelQueue = modelUrls.slice();
      var textureQueue = textureUrls.slice();
      var modelWorkers = Math.min(2, modelQueue.length);
      var textureWorkers = Math.min(2, textureQueue.length);

      for (var index = 0; index < modelWorkers; index += 1) {
        tasks.push(workerFactory(modelQueue, warmModelRequest)());
      }

      for (var textureIndex = 0; textureIndex < textureWorkers; textureIndex += 1) {
        tasks.push(workerFactory(textureQueue, preloadAsset)());
      }

      Promise.allSettled(tasks).catch(function () {
        return null;
      });
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(begin, { timeout: 1600 });
      return;
    }

    window.setTimeout(begin, 280);
  };

  ViewerController.prototype.findVariantById = function (variantId) {
    var normalizedId = String(variantId || "");

    return (
      this.variants.find(function (variant) {
        return String(variant.id) === normalizedId;
      }) || null
    );
  };

  ViewerController.prototype.findMatchingVariants = function (candidateOptions) {
    return this.variants.filter(function (variant) {
      return candidateOptions.every(function (value, index) {
        return !value || variant.options[index] === value;
      });
    });
  };

  ViewerController.prototype.findVariantFromForm = function () {
    if (!this.productForm) {
      return null;
    }

    var idElements = getFormElementsByName(this.productForm, "id");
    var currentVariantId = idElements.length ? idElements[0].value : null;
    var directMatch = this.findVariantById(currentVariantId);

    if (directMatch) {
      return directMatch;
    }

    var optionValues = this.data.options.map(
      function (option) {
        return getSelectedFormValue(this.productForm, option.name);
      }.bind(this)
    );

    return (
      this.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === optionValues[index];
        });
      }) || null
    );
  };

  ViewerController.prototype.handleOptionClick = function (button) {
    var position = toNumber(button.getAttribute("data-option-position"));

    if (position === null) {
      return;
    }

    var candidateOptions = this.selectedOptions.slice();
    candidateOptions[position] = button.getAttribute("data-option-value");

    var nextVariant =
      this.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === candidateOptions[index];
        });
      }) || this.findMatchingVariants(candidateOptions)[0];

    if (!nextVariant) {
      return;
    }

    this.applyVariant(nextVariant, { syncForm: this.data.syncWithProductForm });

    if (this.isOpen) {
      this.loadVariant(nextVariant, { highPriority: true });
    }
  };

  ViewerController.prototype.applyVariant = function (variant, options) {
    options = options || {};

    if (!variant) {
      return;
    }

    this.selectedVariant = variant;
    this.selectedOptions = Array.isArray(variant.options) ? variant.options.slice() : [];
    this.updateOptionGroups();
    this.updateStatus("preparing");

    if (options.syncForm) {
      this.syncProductForm(variant);
    }
  };

  ViewerController.prototype.updateOptionGroups = function () {
    var self = this;

    this.optionGroups.forEach(function (group) {
      var position = toNumber(group.getAttribute("data-option-position"));
      var optionName = group.getAttribute("data-option-name");
      var values = Array.prototype.slice.call(group.querySelectorAll("[data-option-value]"));
      var distinctValues = new Set(
        self.variants
          .map(function (variant) {
            return variant.options[position];
          })
          .filter(Boolean)
      );
      var label = group.querySelector("[data-option-current]");
      var isVisibleOption =
        !self.visibleOptionNames || self.visibleOptionNames.has(normalizeName(optionName));

      values.forEach(function (button) {
        var value = button.getAttribute("data-option-value");
        var nextOptions = self.selectedOptions.slice();
        nextOptions[position] = value;
        var matches = self.findMatchingVariants(nextOptions);
        var isSelected = self.selectedOptions[position] === value;

        button.disabled = !matches.length;
        button.classList.toggle("is-selected", isSelected);
        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
      });

      group.hidden = !isVisibleOption || distinctValues.size < 2;

      if (label) {
        label.textContent = self.selectedOptions[position] || "";
      }
    });
  };

  ViewerController.prototype.updateStatus = function (state, messageOverride) {
    if (!this.status || !this.selectedVariant) {
      return;
    }

    var variantTitle = this.selectedVariant.title || this.selectedVariant.options.join(" / ");
    var modelUrl = this.getModelUrl(this.selectedVariant);
    var modelCached = modelUrl ? globalCache.assetUrls.has(modelUrl) : false;
    var message;

    if (messageOverride) {
      message = messageOverride;
    } else if (state === "loading") {
      message = "Loading the 3D model for variant " + variantTitle + ".";
    } else if (state === "error") {
      message = "The 3D model for variant " + variantTitle + " could not be loaded correctly.";
    } else if (modelCached) {
      message = "The 3D model for variant " + variantTitle + " is ready to view.";
    } else {
      message = "Preparing the 3D model for variant " + variantTitle + ".";
    }

    this.status.textContent = message;
  };

  ViewerController.prototype.setLoading = function (isLoading) {
    if (this.loadingState) {
      this.loadingState.hidden = !isLoading;
    }

    if (this.viewerPanel) {
      this.viewerPanel.setAttribute("aria-busy", isLoading ? "true" : "false");
    }

    this.updateStatus(isLoading ? "loading" : "ready");
  };

  ViewerController.prototype.showError = function (title, message) {
    if (this.errorTitle) {
      this.errorTitle.textContent = title || "The 3D model could not be loaded";
    }

    if (this.errorText) {
      this.errorText.textContent =
        message || "Check whether the product has valid 3D media configured in Shopify.";
    }

    if (this.errorState) {
      this.errorState.hidden = false;
    }

    this.updateStatus("error", message || "The 3D model did not load correctly.");
  };

  ViewerController.prototype.clearError = function () {
    if (this.errorState) {
      this.errorState.hidden = true;
    }
  };

  ViewerController.prototype.applyViewerMedia = function (variant) {
    var model = this.getModelForVariant(variant);
    var poster = (model && model.poster) || this.defaultPoster;

    if (poster) {
      this.viewer.setAttribute("poster", poster);
      preloadPoster(poster);
    } else {
      this.viewer.removeAttribute("poster");
    }

    if (model && model.src) {
      this.viewer.setAttribute("ar", "");
      this.viewer.setAttribute("ar-modes", "quick-look webxr scene-viewer");

      if (model.usdz) {
        this.viewer.setAttribute("ios-src", model.usdz);
      } else {
        this.viewer.removeAttribute("ios-src");
      }
    } else {
      this.viewer.removeAttribute("ios-src");
      this.viewer.removeAttribute("ar");
      this.viewer.removeAttribute("ar-modes");
    }
  };

  ViewerController.prototype.resetViewerCamera = function () {
    if (!this.viewer) {
      return;
    }

    this.viewer.setAttribute("camera-orbit", "-38deg 78deg 110%");
    this.viewer.setAttribute("camera-target", "0m 0.22m 0m");
    this.viewer.setAttribute("field-of-view", "26deg");

    if (typeof this.viewer.jumpCameraToGoal === "function") {
      try {
        this.viewer.jumpCameraToGoal();
      } catch (error) {
        return null;
      }
    }
  };

  ViewerController.prototype.setViewerSource = async function (sourceUrl, options) {
    options = options || {};

    if (options.forceReload && this.currentViewerSrc === sourceUrl) {
      this.currentViewerSrc = null;
      this.appliedMaterialKey = null;
      this.viewer.removeAttribute("src");
      await waitForNextFrame();
    }

    if (this.currentViewerSrc !== sourceUrl) {
      this.currentViewerSrc = sourceUrl;
      this.appliedMaterialKey = null;
      this.currentModelLoadPromise = waitForViewerLoad(this.viewer, 18000);
      this.viewer.setAttribute("src", sourceUrl);
    }

    if (this.currentModelLoadPromise) {
      await this.currentModelLoadPromise;
      this.currentModelLoadPromise = null;
    }

    if (this.viewer.updateComplete) {
      try {
        await this.viewer.updateComplete;
      } catch (error) {
        console.warn("SEESOFA 3D viewer: model-viewer update failed.", error);
      }
    }

    if (typeof this.viewer.dismissPoster === "function") {
      try {
        this.viewer.dismissPoster();
      } catch (error) {
        return null;
      }
    }

    return sourceUrl;
  };

  ViewerController.prototype.ensureModelLoaded = async function (variant, options) {
    var modelUrl = this.getModelUrl(variant);

    if (!modelUrl) {
      throw new Error("No 3D model URL is assigned to this product.");
    }

    await ensureModelViewerLibrary();

    var resolvedUrl = modelUrl;
    var useBlobSource = canUseBlobModelSource(modelUrl);

    if (useBlobSource && options.highPriority) {
      resolvedUrl = await preloadAsset(modelUrl);
    } else if (useBlobSource && globalCache.assetUrls.has(modelUrl)) {
      resolvedUrl = globalCache.assetUrls.get(modelUrl);
    }

    this.applyViewerMedia(variant);

    try {
      await this.setViewerSource(resolvedUrl, options);
    } catch (error) {
      if (resolvedUrl !== modelUrl) {
        console.warn("SEESOFA 3D viewer: blob source failed, retrying original model URL.", error);
        await this.setViewerSource(modelUrl, { forceReload: true });
        return modelUrl;
      }

      throw error;
    }

    return resolvedUrl;
  };

  ViewerController.prototype.getTexture = async function (sourceUrl, highPriority) {
    if (!sourceUrl) {
      return null;
    }

    if (this.textureCache.has(sourceUrl)) {
      return this.textureCache.get(sourceUrl);
    }

    var texturePromise = (async function () {
      var resolvedUrl = highPriority ? await preloadAsset(sourceUrl) : sourceUrl;

      if (!highPriority && globalCache.assetUrls.has(sourceUrl)) {
        resolvedUrl = globalCache.assetUrls.get(sourceUrl);
      }

      try {
        return await this.viewer.createTexture(resolvedUrl);
      } catch (error) {
        if (resolvedUrl !== sourceUrl) {
          return this.viewer.createTexture(sourceUrl);
        }

        throw error;
      }
    }.bind(this))();

    this.textureCache.set(sourceUrl, texturePromise);
    return texturePromise;
  };

  ViewerController.prototype.applyVariantMaterials = async function (variant, options) {
    var materials = variant.materials || {};
    var materialState =
      String(variant.id) +
      "::" +
      (materials.fabricTexture || "") +
      "::" +
      normalizeHexColor(materials.frameColor);

    if (this.appliedMaterialKey === materialState) {
      return;
    }

    if (!this.viewer.model || !Array.isArray(this.viewer.model.materials)) {
      this.appliedMaterialKey = materialState;
      return;
    }

    var fabricMaterial = findMaterialByNames(this.viewer.model.materials, [
    "fabric",
    "upholstery",
    "sofa-fabric"
    ]);

    var connectorKeywords = [
      "connector",
      "connect",
      "joint",
      "cross",
      "bar",
      "rod",
      "brace",
      "link",
      "clamp",
      "support",
      "middle",
      "center",
      "tube",
      "pipe",
      "laczenie",
      "łączenie",
      "lacznik",
      "łącznik",
      "poprzeczka",
      "rurka"
    ];

    var sideFrameKeywords = [
      "side",
      "outer",
      "loop",
      "sled",
      "arm",
      "bok",
      "boczny",
      "frame-side",
      "side-frame",
      "outer-frame",
      "leg-side",
      "side-leg"
    ];

    function hasAnyKeyword(materialName, keywords) {
      return keywords.some(function (keyword) {
        return materialName.indexOf(keyword) !== -1;
      });
    }

    var frameMaterials = this.viewer.model.materials.filter(function (material) {
      if (!material || material === fabricMaterial) {
        return false;
      }

      var materialName = normalizeName(material.name);

      return hasAnyKeyword(materialName, sideFrameKeywords);
    });

    if (!frameMaterials.length) {
      frameMaterials = this.viewer.model.materials.filter(function (material) {
        if (!material || material === fabricMaterial) {
          return false;
        }

        var materialName = normalizeName(material.name);
        var looksLikeFrame =
          materialName.indexOf("frame") !== -1 ||
          materialName.indexOf("leg") !== -1 ||
          materialName.indexOf("legs") !== -1 ||
          materialName.indexOf("stelaz") !== -1 ||
          materialName.indexOf("stelaż") !== -1;

        return looksLikeFrame && !hasAnyKeyword(materialName, connectorKeywords);
      });
    }

    if (!frameMaterials.length && fabricMaterial && this.viewer.model.materials.length === 2) {
      frameMaterials = this.viewer.model.materials.filter(function (material) {
        return material && material !== fabricMaterial;
      });
    }

    if (
      fabricMaterial &&
      materials.fabricTexture &&
      fabricMaterial.pbrMetallicRoughness &&
      fabricMaterial.pbrMetallicRoughness.baseColorTexture
    ) {
      try {
        var texture = await this.getTexture(materials.fabricTexture, options.highPriority);

        if (texture && this.selectedVariant && String(this.selectedVariant.id) === String(variant.id)) {
          fabricMaterial.pbrMetallicRoughness.baseColorTexture.setTexture(texture);
        }
      } catch (error) {
        console.warn("SEESOFA 3D viewer: fabric texture could not be applied.", error);
      }
    }

    if (!this.selectedVariant || String(this.selectedVariant.id) !== String(variant.id)) {
      return;
    }

    if (frameMaterials.length && materials.frameColor) {
  var frameColor = normalizeHexColor(materials.frameColor);

  frameMaterials.forEach(function (frameMaterial) {
    if (!frameMaterial.pbrMetallicRoughness) {
      return;
    }

    frameMaterial.pbrMetallicRoughness.setBaseColorFactor(hexToRGBA(frameColor));

    if (frameColor === "#c0c0c0") {
      frameMaterial.pbrMetallicRoughness.setMetallicFactor(1);
      frameMaterial.pbrMetallicRoughness.setRoughnessFactor(0.18);
    } else {
      frameMaterial.pbrMetallicRoughness.setMetallicFactor(0.3);
      frameMaterial.pbrMetallicRoughness.setRoughnessFactor(0.45);
    }
  });
}

    this.appliedMaterialKey = materialState;
  };

  ViewerController.prototype.loadVariant = async function (variant, options) {
    options = options || {};

    if (!variant) {
      return;
    }

    var currentToken = ++this.loadToken;

    this.clearError();
    this.setLoading(true);

    try {
      await this.ensureModelLoaded(variant, options);

      if (currentToken !== this.loadToken) {
        return;
      }

      await this.applyVariantMaterials(variant, options);

      if (currentToken !== this.loadToken) {
        return;
      }
    } catch (error) {
      console.warn("SEESOFA 3D viewer: variant load failed.", error);
      this.showError(
        "The 3D model could not be opened",
        "Check that the product has valid 3D media in Shopify and that the model includes Fabric and Frame materials if you want to switch finishes."
      );
    } finally {
      if (currentToken === this.loadToken) {
        this.setLoading(false);
      }
    }
  };

  ViewerController.prototype.syncProductForm = function (variant) {
    if (!this.productForm || !variant) {
      return;
    }

    this.formSyncInFlight = true;

    this.data.options.forEach(
      function (option, index) {
        setFormValue(this.productForm, option.name, variant.options[index]);
      }.bind(this)
    );

    setFormVariantId(this.productForm, variant.id);

    window.setTimeout(
      function () {
        this.formSyncInFlight = false;
      }.bind(this),
      0
    );
  };

  ViewerController.prototype.openModal = function () {
    var self = this;

    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    this.lastActiveElement = document.activeElement;
    this.isOpen = true;
    this.setModalState("opening");
    document.documentElement.classList.add("seesofa-3d-lock");
    document.body.classList.add("seesofa-3d-lock");
    document.addEventListener("keydown", this.handleKeydown);
    this.loadVariant(this.selectedVariant, { highPriority: true });

    window.requestAnimationFrame(function () {
      self.setModalState("open");
      self.resetViewerCamera();
      if (self.optionGroupsContainer) {
        self.optionGroupsContainer.scrollTop = 0;
      }
      if (self.closeButton) {
        self.closeButton.focus();
      } else if (self.dialog) {
        self.dialog.focus();
      }
    });
  };

  ViewerController.prototype.closeModal = function () {
    var self = this;

    if (!this.isOpen && this.modal.dataset.state === "closed") {
      return;
    }

    this.isOpen = false;
    this.setModalState("closing");
    document.documentElement.classList.remove("seesofa-3d-lock");
    document.body.classList.remove("seesofa-3d-lock");
    document.removeEventListener("keydown", this.handleKeydown);

    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
    }

    this.closeTimer = window.setTimeout(function () {
      self.setModalState("closed");
      self.closeTimer = null;

      if (self.lastActiveElement && typeof self.lastActiveElement.focus === "function") {
        self.lastActiveElement.focus();
      }
    }, 220);
  };

  function initViewers(scope) {
    var roots = Array.prototype.slice.call((scope || document).querySelectorAll("[data-seesofa-3d-root]"));

    roots.forEach(function (root) {
      if (root.dataset.seesofa3dReady === "true") {
        return;
      }

      root.dataset.seesofa3dReady = "true";
      new ViewerController(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initViewers(document);
    });
  } else {
    initViewers(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initViewers(event.target);
  });
})();
